import React, { useState, useEffect, useRef } from 'react';
import { withStyles, Typography, Button, Tooltip, IconButton, Dialog } from '@material-ui/core';
import { connect } from 'react-redux';
import StorageProductList from './StorageProductList';
import {hasPermission, createHistory, parseURL, formatDate} from '../../sc-utilities';
import { LibraryBooks, FindInPage } from '@material-ui/icons';
import * as actions from './store/storageProductActions';
import {NavLink, Redirect} from 'react-router-dom';
import { informationColors } from '../../../themes';
import QRCode from 'qrcode.react';
import '../qrCode.scss';
import ActiveWarehouseForm from '../../sc-logistic/Colli/ActiveWarehouseForm';
import * as colliActions from '../../sc-logistic/Colli/store/colliActions';
import AppLogoLoading from '../../sc-logo';
import * as groupActions from "../../sc-group/Group/store/groupActions";
import { getGroupsLookup, getSecurazeStandard } from '../../sc-dashboard/ProductOverview/ProductsAll';
import { getSecurazeSolution } from '../../sc-dashboard/ProductOverview/ProductsAll';
import {checkIfLoading} from "../../sc-users/User";
import { fetchSecurazeSolutions } from '../../sc-admin/SecurazeSolution/store/securazeSolutionActions';
import { getStorageInfo } from '../product.utilities';

const styles = theme => ({
    "@global": {
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: 'none',
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
            "[class*='MuiButton-contained']": {
                backgroundColor: theme.palette.primary.main,
                color: 'none',
                margin: theme.spacing(),
                '&:hover': {
                    backgroundColor: theme.palette.secondary.main,
                },
            },
            "[class*='MuiTypography-root.chip_NotErased.MuiTypography-body1']": {
                color: theme.palette.warning.dark,
                padding: 1,
                fontSize: 12
            },
            "[class*='MuiTypography-root.chip_Started.MuiTypography-body1']": {
                color: theme.palette.primary.main,
                padding: 1,
                fontSize: 12
            },
            "[class*='MuiTypography-root.chip_Erased.MuiTypography-body1']": {
                color: theme.palette.success.dark,
                padding: 1,
                fontSize: 12
            },
            "[class*='MuiTypography-root.chip_InProgress.MuiTypography-body1']": {
                color: theme.palette.info.dark,
                padding: 1,
                fontSize: 12
            },
            "[class*='MuiTypography-root.chip_Error.MuiTypography-body1']": {
                color: theme.palette.error.dark,
                padding: 1,
                fontSize: 12
            },
            "[class*='MuiTypography-root.chip_Warning.MuiTypography-body1']": {
                color: theme.palette.error.light,
                padding: 1,
                fontSize: 12
            },
            "[class*='MuiButtonBase-root']": {
                textTransform: 'none',
                textDecoration: 'none',
                color: 'none'
            }
        },
    },
    paletteButtons: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.buttonText.default,
        margin: theme.spacing(),
        minWidth: '24px',
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    button: {
        textTransform: 'none',
        textDecoration: 'none'
    },
    statusActive: {
        color: theme.palette.success.dark
    },
    statusInactive: {
        color: theme.palette.error.dark
    },
    Erased: {
        color: theme.palette.success.dark,
        padding: 1,
        fontSize: 12
    },
    NotErased: {
        color: theme.palette.warning.dark,
        padding: 1,
        fontSize: 12
    },
    Started: {
        color: theme.palette.warning.dark,
        padding: 1,
        fontSize: 12
    },
    InProgress: {
        color: theme.palette.info.dark,
        padding: 1,
        fontSize: 12
    },
    Error: {
        color: theme.palette.error.dark,
        padding: 1,
        margin: 1,
        fontSize: 12
    },
    Warning: {
        color: theme.palette.error.light,
        padding: 1,
        fontSize: 12
    },
    loading: {
      backgroundColor: "transparent",
      boxShadow: "none",
      overflow: "hidden",
      alignItems: "center"
    },
});

const StorageProduct = props => {
    const { classes, translations, permissions, onFetchErasureMethods, activeCustomerID, columns, onFetchWarehouse, setActiveWarehouse, activeWarehouseID, activeCustomer, fetchGroups, onFetchSecurazeSolutions } = props;
    let visible = columns && columns['StorageProduct'];
    let searchParams = parseURL(window.location.search);
    const [groups, setGroups] = useState(null);
    const [loading, setLoading] = useState({groups: false});

    const tableRef = useRef();

    const [erasureMethods, setErasureMethod] = useState({ data: null, loading: false });

    const [warehouseActive, setWarehouseActive] = useState({ loading: false, open: false, data: [], name: [] });
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, orderID: null, redirectPath: "" });

    const [securazeSolutionsLookup, setSecurazeSolutionsLookup] = useState({ data: null, loading: false });

    useEffect(() => {
        const getGroups = async () => {
          setLoading(prevState => { return {...prevState, groups: true} });
          const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomerID});
          if (resultGroups) {
              setGroups(resultGroups.data);
          }
          setLoading(prevState => { return {...prevState, groups: false} });
      }
    
        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
        // eslint-disable-next-line
      }, []);

    useEffect(() => {

        const fetchSecurazeSolutions = async () => {
            setSecurazeSolutionsLookup({ data: null, loading: true });
            let data = await onFetchSecurazeSolutions({ ActiveCustomerID: activeCustomerID });
            let securazeSolutionsLookup = data?.reduce((acc, item) => {
                acc[item.Key] = item.LongName;
                return acc;
            }, {});
            setSecurazeSolutionsLookup({ data: securazeSolutionsLookup, loading: false });
        };
        hasPermission(permissions, "securaze_solution_list") && fetchSecurazeSolutions();
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    const groupsLookup = getGroupsLookup(groups, translations, permissions);

    const createPaletteAction = (product, paletteType) => {
        return product[`${paletteType}ID`] ?
            <Button className={classes['paletteButtons']} key={product[`${paletteType}ID`]} color="primary" variant="contained"
                value={product[paletteType][`${paletteType}InventoryID`]} size='small' onClick={event => {
                    switch (paletteType) {
                        case 'Colli':
                            return goToColli(event);
                        case 'Order':
                            return goToOrder(event);
                        case 'TransportColli':
                            return goToTransportColli(event);
                        default:
                            return null;
                    }
                }}>
                {product[paletteType][`${paletteType}InventoryID`]}
            </Button> : '[empty]';
    }

    const getEraseStatus = (status, forStyle) => {
        switch (status) {
            case 'erased':
                return forStyle ? 'Erased' : translations['erased'] || 'Erased';
            case 'noterased':
                return forStyle ? 'NotErased' : translations['not_erased'] || 'Not erased';
            case 'inprogress':
                return forStyle ? 'InProgress' : translations['in_progress'] || 'In progress';
            case 'error':
                return forStyle ? 'Error' : translations['error'] || 'Error'
            case 'warning':
                return forStyle ? 'Warning': translations['warning'] || 'Warning';
            case 'aborted':
                return forStyle ? 'Aborted' : translations['aborted_by_user'] || 'Aborted by user';
            case 'started':
                return forStyle ? 'Started' : translations['started'] || 'Started';
            default:
                return forStyle ? 'NotErased' : translations['not_erased'] || 'Not erased';
        }
    }

    const getVerificationStatus = (status, forStyle) => {
        switch (status) {
            case 'verified':
                return forStyle ? 'Erased' : translations['verified'] || 'Verified';
            case 'notverified':
                return forStyle ? 'NotErased' : translations['not_verified'] || 'Not verified';
            case 'inprogress':
                return forStyle ? 'InProgress' : translations['in_progress'] || 'In progress';
            case 'error':
                return forStyle ? 'Error' : translations['error'] || 'Error'
            case 'warning':
                return forStyle ? 'Warning': translations['warning'] || 'Warning';
            case 'aborted':
                return forStyle ? 'Aborted' : translations['aborted_by_user'] || 'Aborted by user';
            case 'started':
                return forStyle ? 'Started' : translations['started'] || 'Started';
            default:
                return forStyle ? 'NotErased' : translations['not_verified'] || 'Not verified';
        }
    }

    const getStorageComponentData = (components, field) => {
        let prettyPrint = components.slice(0, 3).map((component, index) => {
            let storageComponent = typeof component.StorageComponents === 'object' && component.StorageComponents instanceof Array && component.StorageComponents.length > 0 ? component.StorageComponents[0] : false;
            if (!storageComponent) {
                return '';
            }
            switch (field) {
                case 'WipeStatus':
                    if (storageComponent[field] === 'inprogress') {
                        return <CustomChip key={`${component.ComponentID}_wipeStatus`} value={`${storageComponent.WipeProgress ? storageComponent.WipeProgress : 0}% ${translations && translations['in_progress'] ? translations['in_progress'] : 'In progress'}`}
                            className={`chip_${getEraseStatus(storageComponent[field], true)}`} />;
                    }
                    let labelText1 = getEraseStatus(storageComponent[field]);
                    return <CustomChip key={`${component.ComponentID}_wipeStatus`} value={labelText1}
                        className={`chip_${getEraseStatus(storageComponent[field], true)}`} />;
                case 'VerificationStatus':
                    if (storageComponent[field] === 'inprogress') {
                        return <CustomChip key={`${component.ComponentID}_verificationStatus`} value={`${storageComponent.VerificationProgress ? storageComponent.VerificationProgress : 0}% ${translations && translations['in_progress'] ? translations['in_progress'] : 'In progress'}`}
                            className={`chip_${getVerificationStatus(storageComponent[field], true)}`} />;
                    }
                    let labelText2 = getVerificationStatus(storageComponent[field]);
                    return <CustomChip key={`${component.ComponentID}_verificationStatus`} value={labelText2}
                        className={`chip_${getVerificationStatus(storageComponent[field], true)}`} />;
                case 'WipeMethod':
                    return <Typography key={`${component.ComponentID}_${index}_wipeMethod`}
                        style={{ fontSize: 12 }}
                        gutterBottom>{erasureMethods.data[storageComponent[field]]}</Typography>;
                default:
                    return '';
            }
        });
        return (prettyPrint);
    };

    const getIcon = icon => {
        switch (icon) {
            case 'FindInPage':
                return <FindInPage />
            case 'LibraryBooks':
                return <LibraryBooks />
            default:
                return <LibraryBooks />
        }
    };

    useEffect(() => {
        const fetchWarehouse = async () => {
            let warehouses = await onFetchWarehouse({ ActiveCustomerID: activeCustomerID });
            let data
            if (!activeWarehouseID && !(searchParams && searchParams.WarehouseInventoryID)) {
                if (warehouses.length > 1) {
                    setWarehouseActive({ loading: true, open: true, data: warehouses, name: warehouses })
                }
                if (warehouses.length === 1) {
                    await setActiveWarehouse({ ActiveCustomerID: activeCustomerID, ActiveWarehouseID: warehouses[0].value })
                    data = warehouses.filter(data => data.value === activeWarehouseID)
                    setWarehouseActive({ loading: true, open: false, data: warehouses, name: warehouses })
                }
                if (warehouses.length === 0) {
                    setWarehouseActive({ loading: true, open: false, data: [], name: [] })
                }
            }
            if (activeWarehouseID && !(searchParams && searchParams.WarehouseInventoryID)) {
                if (warehouses.length > 0) {
                    data = warehouses.filter(params => params.value === activeWarehouseID)
                    setWarehouseActive({ loading: true, open: false, data: warehouses, name: data })
                }
                if (warehouses.length === 0) {
                    setWarehouseActive({ loading: true, open: false, data: [], name: [] })
                }
                if (warehouses.length === 1) {
                    await setActiveWarehouse({ ActiveCustomerID: activeCustomerID, ActiveWarehouseID: warehouses[0].value })
                    setWarehouseActive({ loading: true, open: false, data: warehouses, name: warehouses })
                }
            }
            if (searchParams && searchParams.WarehouseInventoryID) {
                if (warehouses.length > 1) {
                    data = warehouses.filter(params => params.inventoryID.toString() === searchParams.WarehouseInventoryID)
                    setWarehouseActive({ loading: true, open: false, data: warehouses, name: data })
                }
                if (warehouses.length === 0) {
                    setWarehouseActive({ loading: true, open: false, data: [], name: [] })
                }
                if (warehouses.length === 1) {
                    await setActiveWarehouse({ ActiveCustomerID: activeCustomerID, ActiveWarehouseID: warehouses[0].value })
                    setWarehouseActive({ loading: true, open: false, data: warehouses, name: warehouses })
                }
            }
        };

        const fetchErasureMethods = async () => {
            let erasureMethodData = await onFetchErasureMethods({ ActiveCustomerID: activeCustomerID });
            let formattedErasureMethods = erasureMethodData.reduce(
                (obj, item) => Object.assign(obj, { [item.value]: item.displayValue }), {});
            setErasureMethod({ data: formattedErasureMethods, loading: true });
        };
        fetchErasureMethods()
        fetchWarehouse();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeWarehouseID]);

    const tableActions = [
        {
            icon: 'FindInPage',
            tooltip: translations['storage_details'] || "Storage details",
            onClick: (event, rowData) => goToStorageProduct(rowData.ProductID, rowData.Components[0] ? rowData.Components[0].ComponentID : null),
            hidden: !hasPermission(permissions, 'product_load')
        },
    ];

    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 200, maxWidth: 200 },
            filtering: false,
            sorting: false,
            render: rowData => {
                return tableActions.map(action => {
                    if (action.hidden) {
                        return null;
                    }

                    const iconButton = <IconButton component='div' onClick={(event) => action.onClick(event, rowData)}>
                                            {getIcon(action.icon)}
                                        </IconButton>

                    const activeCustomerParams = `&ActiveCustomerID=${activeCustomerID}&ActiveCustomerName=${activeCustomer?.Name}`;
                    const detailsLink = `/storage-product/details?productID=${rowData.ProductID}&&type=StorageProduct&&componentID=${rowData.Components[0] ? rowData.Components[0].ComponentID : null}${activeCustomerParams}`;

                    return (
                        <Tooltip key={`${action.icon}-${rowData.OrderID}`} title={action.tooltip} >
                            {action.icon==="FindInPage" ?
                                <NavLink to={detailsLink}>
                                    {iconButton}
                                </NavLink> : iconButton}
                        </Tooltip>
                    )
                })
            },
        },
        {
            field: 'QRCode',
            title: translations["qr_code"] || 'QR Code',
            hidden: visible ? visible['QRCode'] : true,
            filtering: false,
            sorting: false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            render: rowData => {
                return getQRCode(rowData.InventoryID);
            },
        },
        {
            field: 'InventoryID',
            title: translations["inventory_id"] || 'Securaze ID',
            hidden: visible ? visible['InventoryID'] : false,
            defaultFilter: searchParams && searchParams.InventoryID ? searchParams.InventoryID : '',
            sorting: false,
            render: rowData => {
                return rowData.InventoryID ? rowData.InventoryID : translations['short_not_assigned'] || 'n/a';
            },
        },
        {
            field: 'InventoryNumber',
            title: translations['inventory_number'] || 'Inventory number',
            sorting: false,
            hidden: visible ? visible['InventoryNumber'] : false,
            render: (rowData) => {
                return (
                    <Typography variant={'caption'}>
                        {rowData.InventoryNumber
                            ? rowData.InventoryNumber
                            : translations['short_not_assigned'] || 'n/a'}
                    </Typography>
                );
            },
        },
        {
            field: 'SKU',
            title: translations['sku'] || 'SKU',
            hidden: visible ? visible['SKU'] : false,
            render: (rowData) => {
                return (
                    <Typography variant={'caption'}>
                        {rowData?.SKU ?? (translations['short_not_assigned'] || 'n/a')}
                    </Typography>
                );
            },
        },
        {
            title: translations["order"] || "Order", field: 'OrderInventoryID',
            hidden: visible ? visible['OrderInventoryID'] : false,
            defaultFilter: searchParams && searchParams.OrderInventoryID ? searchParams.OrderInventoryID : '',
            sorting: false,
            render: rowData => {
                return rowData.Order ? createPaletteAction(rowData, 'Order', classes) : translations['short_not_assigned'] || 'n/a';
            },
        },
        {
            title: translations["transport_collies"] || "Transport collies", field: 'TransportColliInventoryID',
            defaultFilter: searchParams && searchParams.TransportColliInventoryID ? searchParams.TransportColliInventoryID : '',
            hidden: visible ? visible['TransportColliInventoryID'] : false,
            sorting: false,
            render: rowData => {
                return rowData.TransportColli ? createPaletteAction(rowData, 'TransportColli', classes) : translations['short_not_assigned'] || 'n/a';
            },
        },
        {
            title: translations["colli"] || 'Colli', field: 'ColliInventoryID',
            hidden: visible ? visible['ColliInventoryID'] : false,
            defaultFilter: searchParams && searchParams.ColliInventoryID ? searchParams.ColliInventoryID : '',
            sorting: false,
            render: rowData => {
                return rowData.Colli ? createPaletteAction(rowData, 'Colli', classes) : translations['short_not_assigned'] || 'n/a';
            }
        },
        {
            title: translations["serial"] || 'Serial', field: 'SerialNumber',
            hidden: visible ? visible['SerialNumber'] : false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            sorting: false,
            render: rowData => {
                return <> {rowData.Components && rowData.Components.length > 0 && rowData.Components[0].SerialNumber && rowData.Components[0].SerialNumber.length > 15 ?
                    <Tooltip key={`${rowData.Components[0].SerialNumber}-${rowData.ProductID}`} title={rowData.Components[0].SerialNumber}>
                        <Typography variant={'caption'}>{rowData.Components[0].SerialNumber.slice(0, 14)}...</Typography>
                    </Tooltip>
                    : <Typography variant={'caption'}>{rowData.Components && rowData.Components.length > 0 && rowData.Components[0].SerialNumber ? rowData.Components[0].SerialNumber : translations['short_not_assigned'] || 'n/a'}</Typography>}</>
            }
        },
        {
            title: translations["vendor"] || 'Vendor', field: 'Vendor',
            hidden: visible ? visible['Vendor'] : false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            sorting: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Vendor ?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
            }
        },
        {
            title: translations["model"] || 'Model', field: 'ComponentModel',
            hidden: visible ? visible['ComponentModel'] : false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            sorting: false,
            filtering: false,
            render: rowData => {
                return <> {rowData.Components && rowData.Components.length > 0 && rowData.Components[0].ComponentModel && rowData.Components[0].ComponentModel.length > 15 ?
                    <Tooltip key={`${rowData.Components[0].ComponentModel}-${rowData.ProductID}`} title={rowData.Components[0].ComponentModel}>
                        <Typography variant={'caption'}>{rowData.Components[0].ComponentModel.slice(0, 14)}...</Typography>
                    </Tooltip>
                    : <Typography variant={'caption'}>{rowData.Components && rowData.Components.length > 0 && rowData.Components[0].ComponentModel ? rowData.Components[0].ComponentModel : translations['short_not_assigned'] || 'n/a'}</Typography>}</>
            }
        },
        {
            title: translations["size"] || 'Size', field: 'Size',
            hidden: visible ? visible['Size'] : false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            sorting: false,
            filtering: false,
            render: rowData => {
                return <> {
                <Typography variant={'caption'}>{rowData?.Components?.[0]?.StorageComponents?.[0]?.Size ? getStorageInfo(rowData, 'size', classes, translations) : translations['short_not_assigned'] || 'n/a'}</Typography>}</>
            }
        },
        {
            title: translations["created_at"] || 'Created at', field: 'CreatedAt',
            hidden: visible ? visible['CreatedAt'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.CreatedAt ? formatDate(rowData.CreatedAt) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["wipe_status"] || 'Wipe status', field: 'WipeStatus',
            hidden: visible ? visible['WipeStatus'] : false,
            filtering: false,
            sorting: false,
            lookup: { 'erased': 'Erased', 'noterased': 'Not Erased', 'inprogress': 'In progress', 'error': 'Error', 'warning': 'Warning', 'aborted': 'Aborted by user', 'started': 'Started' },
            render: rowData => {
                return getStorageComponentData(rowData.Components, 'WipeStatus')
            }
        },
        {
            title: translations["verification_status"] || 'Verification status', field: 'VerificationStatus',
            hidden: visible ? visible['VerificationStatus'] : false,
            filtering: false,
            sorting: false,
            lookup: { 'verified': 'Verified', 'notverified': 'Not Verified', 'inprogress': 'In progress', 'error': 'Error', 'warning': 'Warning', 'aborted': 'Aborted by user', 'started': 'Started' },
            render: rowData => {
                return getStorageComponentData(rowData.Components, 'VerificationStatus')
            }
        },
        {
            title: translations["securaze_standard"] || 'Securaze Standard', field: 'WipeMethod',
            hidden: visible ? visible['WipeMethod'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            lookup: erasureMethods.data,
            sorting: false,
            render: rowData => {
                return <Typography variant={'caption'}>{getSecurazeStandard(rowData)}</Typography>;
            }
        },
        {
            title: translations["securaze_solution"] || 'Securaze Solution', field: 'SecurazeSolution',
            hidden: visible ? visible['SecurazeSolution'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            lookup: securazeSolutionsLookup.data || {},
            sorting: false,
            render: rowData => {
                return <Typography variant={'caption'}>{getSecurazeSolution(rowData)}</Typography>;
            }
        },
        {
            title: translations["group"] || 'Group', field: 'GroupID',
            cellStyle: { minWidth: 100, maxWidth: 100 },
            hidden: visible ? visible['GroupID'] : false,
            lookup: groupsLookup,
            defaultFilter: searchParams?.GroupID? [searchParams.GroupID] : groups? Object.keys(groupsLookup) : [],
            sorting: false,
            render: rowData => {
                return <Typography style={{ fontSize: 12 }} gutterBottom>{rowData?.Group? rowData.Group?.Name : (translations['short_not_assigned'] || 'n/a')}</Typography>
            }
        },
        {
            title: translations["shredded"] || 'Shredded', field: 'Shredded',
            hidden: visible ? visible['Shredded'] : false,
            lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
            defaultFilter: ['0', '1'],
            sorting: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData?.Components?.[0]?.StorageComponents?.[0]?.Shredded ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        },
    ];

    tableColumns = hasPermission(permissions, 'group_list')? tableColumns : tableColumns.filter((column) => column.field!=="GroupID");

    const goToColli = event => {
        let colliInventoryID = event.currentTarget.value;
        createHistory();
        setRedirectOptions({
            redirect: true,
            colliInventoryID: event.currentTarget.value,
            redirectPath: `/logistic/container?ColliInventoryID=${colliInventoryID}`
        });
    }
    const goToStorageProduct = (productID, componentID) => {
        createHistory();
        setRedirectOptions({
            redirect: true,
            productID: productID,
            redirectPath: `/storage-product/details?productID=${productID}&&type=StorageProduct&&componentID=${componentID}`
        });
    }

    const goToOrder = event => {
        let orderInventoryID = event.currentTarget.value;
        createHistory();
        setRedirectOptions({
            redirect: true,
            orderInventoryID: event.currentTarget.value,
            redirectPath: `/logistic/orders?OrderInventoryID=${orderInventoryID}`
        });
    }

    const goToTransportColli = event => {
        let transportColliInventoryID = event.currentTarget.value;
        createHistory();
        setRedirectOptions({
            redirect: true,
            transportColliInventoryID: event.currentTarget.value,
            redirectPath: `/logistic/transport-container?TransportColliInventoryID=${transportColliInventoryID}`
        });
    }

    const getQRCode = inventoryID => {
        return (
            <div className="tooltip">
                <QRCode
                    size={50}
                    value={`<Product>${inventoryID}</Product>`}
                />
                <span>
                    <QRCode
                        size={200}
                        value={`<Product>${inventoryID}</Product>`}
                    />
                </span>
            </div>
        );
    }

    const goToCreateStorageProduct = () => {
        createHistory();
        setRedirectOptions({ redirect: true, StorageProductID: null, redirectPath: `/order/create` });
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{classes: {root: classes.loading}}}>
        <AppLogoLoading />
    </Dialog>

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'product_list') && warehouseActive.loading && erasureMethods.loading ? (
                !warehouseActive.open ?
                    loading.groups? loadingScreen : <StorageProductList
                        groups={groups}
                        warehouseActive={warehouseActive}
                        setWarehouseActive={setWarehouseActive}
                        tableColumns={tableColumns}
                        goToCreateStorageProduct={goToCreateStorageProduct}
                        tableRef={tableRef}
                    /> :
                    <ActiveWarehouseForm setWarehouseActive={setWarehouseActive} handleCloseActiveWarehouseForm={() => setWarehouseActive({ ...warehouseActive, open: false })} warehouses={warehouseActive} />
            ) : null}
        </div>
    );

}
const CustomChip = props => {
    const { keyValue, value, className } = props;
    let possibleStyles = {
        chip_Erased: {
            color: informationColors.success.dark,
            padding: 1,
            fontSize: 12
        },
        chip_NotErased: {
            color: informationColors.warning.dark,
            padding: 1,
            fontSize: 12
        },
        chip_InProgress: {
            color: informationColors.customInProgress.dark,
            padding: 1,
            fontSize: 12
        },
        chip_Error: {
            color: informationColors.error.dark,
            padding: 1,
            margin: 1,
            fontSize: 12
        },
        chip_Warning: {
            color: informationColors.error.light,
            padding: 1,
            fontSize: 12
        },
        chip_Aborted: {
            color: informationColors.aborted.main,
            padding: 1,
            fontSize: 12
        },
        chip_Started: {
            color: informationColors.started.main,
            padding: 1,
            fontSize: 12
        },
    }
    return (
        <Typography key={keyValue} className={className} style={possibleStyles[className]}>{capitalize(value)}</Typography>
    );
};

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}
const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        activeWarehouseID: state.core.login.user.ActiveWarehouseID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        activeCustomer: state.core.login.activeCustomer,
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchErasureMethods: (user) => (dispatch(actions.fetchErasureMethod(user))),
        onFetchWarehouse: (params) => dispatch(colliActions.listWarehouse(params)),
        setActiveWarehouse: (params) => dispatch(colliActions.setActiveWarehouse(params)),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params)),
        onFetchSecurazeSolutions: (data) => dispatch(fetchSecurazeSolutions(data)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(StorageProduct));